import { render, staticRenderFns } from "./SectionDiagnosis.vue?vue&type=template&id=138e2762&scoped=true&"
import script from "./SectionDiagnosis.vue?vue&type=script&lang=js&"
export * from "./SectionDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./SectionDiagnosis.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SectionDiagnosis.vue?vue&type=style&index=1&id=138e2762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138e2762",
  null
  
)

export default component.exports